import { useTranslation } from "react-i18next";
import type { TipIssue } from "./tipMath";

/** Текстът на отказ по кода — каталогът на BE, огледан в
 *  `closeTable.tip.errors.*` (BG/EN). Липсващото право е текстът на
 *  преведената 403-ка (`errors.missingPermission`, `api/client.ts`); пътят на
 *  ЗАПИСАНИЯ бакшиш (повторен опит) има свой текст — там се сменя само
 *  методът на сметката. */
export function useTipIssueText() {
  const { t } = useTranslation();
  return (issue: TipIssue) => {
    if (issue.code === "missing_permission") {
      return t("errors.missingPermission", { permission: issue.permission });
    }
    if (issue.recorded && issue.code === "tip_method_wrong_path") {
      return t("closeTable.tip.recordedWrongPath", { method: issue.method });
    }
    return t(`closeTable.tip.errors.${issue.code}`, {
      amount: issue.amount,
      max: issue.max,
      threshold: issue.threshold,
      method: issue.method,
    });
  };
}
